<template>
    <div class="rare">
      <Search title="可治性罕见病" :attent="num + '项携带'" :total="'共计评价' + total + '种疾病'" :child="child" backurl="/home">
        <div class="box">
          <van-tabs v-model="activeTab">
            <van-tab title="携带项目">
              <div class="noCarry" v-if="carry_list.length === 0 && !loading2">
                <img src="../../assets/images/nothing2.png" alt="未携带">
              </div>

              <div v-else class="risk-cell" v-for="(item, index) in carry_list" :key="index" @click.stop="$router.push('/rareInfo/' + item.id)">
                <p class="title">{{item.name}}</p>
                <p v-if="child !== '1'">遗传模式：<span>{{ item.inherit_type }}</span></p>
              </div>
            </van-tab>

            <van-tab title="全部项目">
              <ul>
                <li class="risk-cell no_click" v-for="(item, index) in data" :key="index">
                  <p class="title">{{item.name}}</p>
                  <div v-if="child !== '1'">
                    <p v-if="item.id">基因：{{ item.gene_name }} &nbsp;&nbsp; 遗传：{{item.inherit_type}}</p>
                  </div>
                  <div v-if="item.id" class="right-icon" :class="item.id && 'high-level'">携带</div>
                  <div v-else class="right-icon" >未携带</div>
                </li>
                <li class="seeMore">
                  <span @click.stop="loadMore" v-if="has_next && !loading">查看更多</span>
                </li>
              </ul>
              <div style="width: 28px;margin: 20px auto;" v-if="loading && this.data.length === 0 ">
                <van-loading color="#1989fa" />
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'index',
  data () {
    return {
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      num: '',
      total: '',
      activeTab: 0,
      carry_list: [], // 携带的可治罕见病列表
      data: [], // 全部可治罕见病列表接口
      page: 0,
      has_next: true,
      loading: false,
      loading2: true,
      totaldata: 0,
      child:0,
    }
  },
  methods: {
    // 数量接口
    getQuantity () {
      this.util.get(this.api.rare_quantity, '', (success) => {
        this.num = success.num
        this.total = success.total
      })
    },
    loadMore () {
      let that = this
      if (!this.has_next) {
        return false
      }
      this.loading = true
      this.page++
      if (that.totaldata < this.total) {
        this.getRareItems()
      } else {
        console.log('不执行')
        that.has_next = false
      }
    },
    getRareCarryRares () {
      this.util.get(this.api.rare_carry_rares, '', (success) => {
        this.carry_list = success.items
        this.loading2 = false
        this.util.setLS('paginationData', success.items)
      })
    },
    getRareItems () {
      this.util.get(this.api.rare_items, '', (success) => {
        this.data = success.items
      })
    }
  },
  mounted () {
    this.child = localStorage.child
    this.getQuantity()
    this.getRareCarryRares()
    this.getRareItems()
  },
  components: {
    Search
  }
}
</script>

<style lang="scss">
  .rare {
    height: 100%;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/rare/index.vue